import { render, staticRenderFns } from "./VisualizarRegiaoModal.vue?vue&type=template&id=6c287002&scoped=true&lang=pug"
import script from "./VisualizarRegiaoModal.vue?vue&type=script&lang=js"
export * from "./VisualizarRegiaoModal.vue?vue&type=script&lang=js"
import style0 from "./VisualizarRegiaoModal.vue?vue&type=style&index=0&id=6c287002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c287002",
  null
  
)

export default component.exports